'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo } from 'react';
const streams = new Map();
const loadStream = (scope, url, onError) => {
  if (!streams.has(url)) {
    const options = {
      path: `/${scope}`,
      transports: ['websocket', 'polling']
    };
    const stream = import('../../personly-libs-stream/src/index.js').then(({
      default: Stream
    }) => new Stream(url, options, onError));
    streams.set(url, stream);
  }
  return streams.get(url);
};
const useStream = (accessToken, onError, onConnectError, scope, url) => {
  const $ = _c(18);
  let t0;
  if ($[0] !== accessToken || $[1] !== onConnectError || $[2] !== onError || $[3] !== scope || $[4] !== url) {
    t0 = async (channel, event, cb) => {
      const stream = await loadStream(scope, url, onError);
      if (accessToken) {
        stream.setAccessToken(accessToken);
      }
      return stream.subscribe(channel, event, cb, err => accessToken ? onConnectError(err, stream.setAccessToken.bind(stream)) : onConnectError(err));
    };
    $[0] = accessToken;
    $[1] = onConnectError;
    $[2] = onError;
    $[3] = scope;
    $[4] = url;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  const subscribe = t0;
  let t1;
  if ($[6] !== onError || $[7] !== scope || $[8] !== url) {
    t1 = async handle => {
      const stream_0 = await loadStream(scope, url, onError);
      return stream_0.unsubscribe(handle);
    };
    $[6] = onError;
    $[7] = scope;
    $[8] = url;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  const unsubscribe = t1;
  let t2;
  if ($[10] !== onError || $[11] !== scope || $[12] !== url) {
    t2 = async (handle_0, event_0) => {
      const stream_1 = await loadStream(scope, url, onError);
      stream_1.emit(handle_0, event_0);
    };
    $[10] = onError;
    $[11] = scope;
    $[12] = url;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  const emit = t2;
  let t3;
  if ($[14] !== emit || $[15] !== subscribe || $[16] !== unsubscribe) {
    t3 = {
      subscribe,
      unsubscribe,
      emit
    };
    $[14] = emit;
    $[15] = subscribe;
    $[16] = unsubscribe;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  const value = t3;
  return value;
};
export default useStream;